import React from "react";
import { useParams } from "react-router";
import { RefActivity } from "../../../api/hooks";
import ActivityView from "../../../common/activity/ActivityView";

const TreatmentDetailActivity = () => {
    const { treatmentId } = useParams<any>();
    return (
        <div>
            {treatmentId && (
                <ActivityView
                    className="mt-3 border"
                    activityRef={RefActivity?.Treatment}
                    activityRefId={treatmentId ?? ""}
                />
            )}
        </div>
    );
};

export default TreatmentDetailActivity;
